import React, { useState, useEffect, useRef  } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import Preloader from "../../components/Preloader/Preloader";
import LoadingOverlay from 'react-loading-overlay';
import {PDFDownloadLink,BlobProvider} from '@react-pdf/renderer';
import {PdfDocument} from "../../components/PDF/WholeSaleSummaryPdf";
import {PdfDocumentRelease} from "../../components/PDF/WholeSaleSummaryPdfRelease";
import {PdfDocumentFS} from "../../components/PDF/PackageSalesSummaryPdfFS";
import ReactToPrint from "react-to-print";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import notreleaseimg from "../../assets/img/empty-cart.gif";
import { useHistory,useParams } from "react-router-dom";
import numeral from "numeral";
// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LoyaltyTwoToneIcon from '@material-ui/icons/LoyaltyTwoTone';
import { Box, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	cardStyleHeight:{
		height:"100%"
	},
	floatright:{
		float:"right"
	},    
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "400px",
		margin: "0 auto",
	},
	modal_itr: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	paddingmarginzero :{
		padding:"0 !important",
		margin:"0 !important",
		fontWeight:"bold"
	},
	margintop:{
		marginTop:"10px"
	},
	printButton:{
		"& a":{color:"#fff !important"}
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
}));

const WholesaleTransactionDetails = (props) => {
	const { idno, fs,eligible } = useParams();
	const classes = useStyles();
	const idnoselected = idno;
	const eligibleforrelease = eligible? eligible : 'no';
	//ApiData Component useState SOF
	const [nextPagePath, setnextPagePath] = useState("");
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
	const [isLoaded, setisLoaded] = useState(false);
	const [headerDetailsP, setHeaderDetailsP] = useState([]);
	const [itemDetailsP, setItemDetailsP] = useState([]);
	const [computationDetailsP, setComputationDetailsP] = useState({});
	const [paymentP, setPaymentP] = useState([]);
	const [showPrint, setHidePrint] = useState(false);
	const history = useHistory();
	//Core datas
	const [memberpaymentsDetails, setmemberpaymentsDetails] = useState({});
	const [memberpaymentsDetailsOthers, setmemberpaymentsDetailsOthers] = useState({});
	const [paymentDetails, setpaymentDetails] = useState({});
	const [itemDetails, setitemDetails] = useState({});
	const [ITRDetails, setITRDetails] = useState({});
	const [computationDetails, setcomputationDetails] = useState({});
	const [transactionDetails, setTransactionDetails] = useState({});
	 const [places, setPlaces] = useState([]);
	 const [disabledBtnYes,setDisabledBtnYes ] = useState(false);
	 const [packages,setPackages ] = useState([]);
	 const [totalSetCount,setTotalSetCount ] = useState(null);
	 const [pdfProps,setPdfProps ] = useState(null);
	const toprint = useRef(null)
	const headers = {
        'Content-Type': 'multipart/form-data',
    };
	const get_packagesales_details = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
			idno: idnoselected,
			jc_curcode: branchCurcode
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'wholesalesummarydetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setmemberpaymentsDetails(res.data.memberpaymentsDetails);
			setmemberpaymentsDetailsOthers(res.data.newInfo);
			setpaymentDetails(res.data.paymentDetails);
			// setPaymentP(res.data.paymentDetails);
			setitemDetails(res.data.itemDetails);
			setcomputationDetails(res.data.computations);

			      const rawNames = res.data.memberpaymentsDetails.package;

			const counts = rawNames
				.split("and")
				.map(n => n.trim())
				.reduce((acc, name) => {
				acc[name] = (acc[name] || 0) + 1;
				return acc;
				}, {});

			const rows = Object.entries(counts).map(
				([name, qty]) => [name, qty]
			);
			const totalCounts = Object.values(counts).reduce(
			(sum, qty) => sum + qty,
			0
			);
			setTotalSetCount(totalCounts);
			setPackages(rows);
			setShowOverlay(false);
		});
	};
	const get_itr_details = async () => {
        await axios.get(
			process.env.REACT_APP_API_URL+'getitrdetails', {
            params:{
                idno: idnoselected
            }
        }).then((res)=>{
			if(res.data.result.success == 1){
				setITRDetails(res.data.result.ITRDetails);
			}
	
		}).catch((error)=>{
			setShowOverlay(false);
			// console.log(error.message);
		})
    }

	const get_packagesales_details_fs = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			idno: idnoselected
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalessummarydetailsfs';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setTransactionDetails(res.data.transactioninfo);
			// setHidePrint(true);
			
		});
	};
	    const getHqLink = () => {
	    //get data for shipping location dropdown
	    const form_data = {
	      branchidno: branchIdNo,
	    };
	    const formData = new FormData();
	    formData.append("form_data", JSON.stringify(form_data));
	    const apiUrl = process.env.REACT_APP_API_URL + "getHqLink";
	    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
		const apiData = res.data.data || [];
	
	      const staticData = {
		id: 0,
		idno: "MAINHQ",
		branchname: "JC Premiere Business International",
		supplier_id:0,
	      };
	
	  
	  setPlaces([staticData, ...apiData]);
	    });
	  };

	const get_packagedetailspdf = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
			idno: idnoselected,
			curcode: branchCurcode
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'getwholesaledetailspdf';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setHeaderDetailsP(res.data.header_details);
			setItemDetailsP(res.data.item_details);
			// if(res.data.item_details.length > 0){
			// 	setItemDetailsP(res.data.item_details);
			// }
			setPaymentP(res.data.paymentDetails);
			setComputationDetailsP(res.data.computations_details);
			// setHidePrint(true);
		});
	};

	const releasepackage = (idno) => {
	setDisabledBtnYes(true);
		// console.log('334',get_cookies('is_operational'))
        setShowOverlay(true);
        setOverlayMsg('Processing Release...');

	    if(get_cookies('is_operational')== 0){
	      if(supplierId === ""){
		setShowOverlay(false);
		  setShowMsgBox(true);
		setMsg("Supplier Missing");
		setMsgType("warning");
		setTimeout(() => {
		  setShowMsgBox(false);
		  	  setDisabledBtnYes(false);
		//   setBtnDisabled(false); // re-enable
		}, 2500);
		return;
	      }else if(selectedPlace !== "MAINHQ"){
		if(selectedPlace == ""){
		setShowOverlay(false);
			  setShowMsgBox(true);
		setMsg("Please Select Purchase From");
		setMsgType("warning");
		setTimeout(() => {
		  setShowMsgBox(false);
		  	  setDisabledBtnYes(false);
		//   setBtnDisabled(false); // re-enable
		}, 2500);
		}
	      }else if(supplierId ==null){
		setShowOverlay(false);
		      setShowMsgBox(true);
		setMsg("Supplier Missing");
		setMsgType("warning");
		setTimeout(() => {
		  setShowMsgBox(false);
		  setDisabledBtnYes(false);
		//   setBtnDisabled(false); // re-enable
		}, 2500);
		return;
	      }
	    }
		//get data for warehouse/location dropdown
		let cleaned = computationDetails.shipping_fee_display.replace(/,/g, ''); // "154970"
		let amount = parseFloat(cleaned);
		const form_data = {
            hqidno: branchIdNo,
			idno: idno,
			      username:get_cookies('username'),
			      hqlink:selectedPlace == "MAINHQ" ? "":selectedPlace,
			      poShippingFee:amount,
			      shipping:amount !==0 ? 1:2,
			      supplierId:supplierId
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'releasepackage';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setDisabledBtnYes(false);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
					history.replace("/wholesale-transaction-history/");
					// window.location.reload(false);
				}, 3000)
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Loading overlay
	const [showOverlay, setShowOverlay] = useState(true);
	const [overLayMsg, setOverlayMsg] = useState(false);
	//Loading overlay EOF

	//Table Settings
	const [TABLE_DATA_PAYMENT, loadPaymentTable] = useState([]);
	const [TABLE_DATA_ITEMS, loadItemTable] = useState([]);
	const [TABLE_DATA_ITR, loadItemToRelease] = useState([]);
	const [dataRelease, setDataRelease] = useState([]);
	  const [selectedPlace, setSelectedPlace] = useState("");
	  const [supplierId, setSupplerId] = useState("");

	const prep_table_payment = () => {
		const newData = [...TABLE_DATA_PAYMENT];
		for (let i=0;i < paymentDetails.length;i++) {
			const tempObj = {paymenttype:paymentDetails[i].paymentid, refno:paymentDetails[i].refno, amount:paymentDetails[i].amount}
			newData.push(tempObj);	
		}
		loadPaymentTable([...newData]);
	};

	const prep_table_item = () => {
		const newData = [...TABLE_DATA_ITEMS];
		for (let i=0;i < itemDetails.length;i++) {
			const tempObj = {count:itemDetails[i].counting, itemname:itemDetails[i].itemname, itemqty:Math.abs(itemDetails[i].qty), unit:itemDetails[i].unit, itemprice:itemDetails[i].itemprice, totalamt:itemDetails[i].totalamount}
			newData.push(tempObj);	
		}
		loadItemTable([...newData]);
	};

	const prep_table_itr = () => {
		const newData = [...TABLE_DATA_ITR];
		for (let i=0;i < ITRDetails.length;i++) {
			const tempObj = {itemname:ITRDetails[i].itemname, itemqty:Math.abs(ITRDetails[i].qty), unit:ITRDetails[i].unit}
			newData.push(tempObj);	
		}
		loadItemToRelease([...newData]);
	};
	const prep_table_data_print= () => {
		const newData = [...TABLE_DATA_ITR];
		for (let i=0;i < ITRDetails.length;i++) {
			const tempObj2 = {description:ITRDetails[i].itemname, qty:Math.abs(ITRDetails[i].qty), unit:ITRDetails[i].unit}
			newData.push(tempObj2);	
		}
		setDataRelease([...newData]);
	};


	const refreshTables = (params) => {
		if(params == "payment"){
			TABLE_DATA_PAYMENT.length = 0;
        	const newData = [...TABLE_DATA_PAYMENT];
			loadPaymentTable([...newData]);
		}else if(params == "itr"){
			TABLE_DATA_ITR.length = 0;
			const newData = [...TABLE_DATA_ITR];
			loadItemToRelease([...newData]);
		}else{
			TABLE_DATA_ITEMS.length = 0;
			const newData = [...TABLE_DATA_ITEMS];
			loadItemTable([...newData]);
		}
	}

	const TABLE_COLUMNS_PAYMENT = [
		{
		  name: 'paymenttype',
		  label: 'Type',
		}, {
		  name: 'refno',
		  label: 'Reference',
		}, {
			name: 'amount',
			label: 'Amount',
						options: {
							customBodyRender: (value, tableMeta, updateValue) => {
								return (
										<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
								);
							  }
							}
		  }
	];

	const TABLE_COLUMNS_ITEMS = [
{
		  name: 'itemname',
		  label: 'Item Name',
		}, {
		  name: 'itemqty',
		  label: 'Qty',
		}, {
			name: 'unit',
			label: 'Unit',
		}, {
			name: 'itemprice',
			label: 'Price',
						options: {
							customBodyRender: (value, tableMeta, updateValue) => {
								return (
										<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
								);
							  }
							}
		}, {
			name: 'totalamt',
			label: 'Total',
						options: {
							customBodyRender: (value, tableMeta, updateValue) => {
								return (
										<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
								);
							  }
							}
		}
	];

	const TABLE_COLUMNS_ITR = [
{
		  name: 'itemname',
		  label: 'Item Name',
		}, {
		  name: 'itemqty',
		  label: 'Qty',
		}, {
			name: 'unit',
			label: 'Unit',
		}
	];
	
	const TABLE_OPTION_PAYMENT = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false,
		pagination: TABLE_DATA_PAYMENT.length > 10, 

	};

	const TABLE_OPTION_ITEMS = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false,
		pagination: false,
	
	};

	const TABLE_OPTION_ITR = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false,
		pagination: false,
	};

		const TABLE_COLUMNS_SET = [
{
		  name: 'name',
		  label: 'Set Name',
		}, {
		  name: 'qty',
		  label: 'Qty',
		}
	];
		const TABLE_OPTION_SET = {
        selectableRows: false,
		viewColumns:false,
		print:false,
		download:false,
		filter:false,
		pagination: false,
	};
const blobRef = useRef(null);

	//Table Settings EOF
	const totalAmount = TABLE_COLUMNS_ITEMS.reduce((sum, row) => sum + row.totalamt, 0);
	//Modal Settings
	const [open, setOpen] = useState(false);
	  const [openModal, setOpenModal] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	//Modal Settings EOF

	//Modal Settings Table of Items
	const [open2, setOpen2] = useState(false);
	  const handleOpenModal = () => {
   		 setOpenModal(true);
  };
    const handleCloseModal = () => {
    setOpenModal(false);
  };
	const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose2 = () => {
		setOpen2(false);
	};

	
	//Modal Settings Table of Items EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
		isLoggedIn();
		getHqLink();
		if(fs == "no"){
			get_packagesales_details();
			get_packagedetailspdf();
			if(eligibleforrelease == "yes"){
				get_itr_details();
			}
			
		}else{
			get_packagesales_details_fs();
		}
    }, []);
	useEffect(() => {
		refreshTables("payment");
		prep_table_payment();
    }, [paymentDetails]);
	useEffect(() => {
		refreshTables("items");
		prep_table_item();
    }, [itemDetails]);
	useEffect(() => {
		refreshTables("itr");
		prep_table_itr();
		prep_table_data_print();
    }, [ITRDetails]);
// 	useEffect(() => {
// 	if(eligibleforrelease == 'yes'){
// 		if(Object.keys(headerDetailsP).length > 0&&Object.keys(computationDetailsP).length > 0&&totalSetCount !=null && packages.length>0){
// 			setHidePrint(true);
// 		}else{
// 			return;
// 		}

// 	}else{
// 		// if(Object.keys(computationDetailsP).length > 0){
// 		// 	console.log(5);
// 		// }else{
// 		// 	console.log(3);
// 		// }
// 		if(Object.keys(headerDetailsP).length > 0&&Object.keys(computationDetailsP).length > 0 &&totalSetCount != null&&packages.length>0){
// 			setHidePrint(true);
// 		}else{
// 			return;
// 		}

// 	// console.log('comp',computationDetailsP)

// 	// console.log('3434',headerDetailsP)

// 	}
//     }, [itemDetails,eligibleforrelease,dataRelease,computationDetailsP,itemDetailsP,totalSetCount,packages]);

const downloadingRef = React.useRef(false);
    const PDFREADY =Object.keys(headerDetailsP).length > 0&&Object.keys(computationDetailsP).length > 0 &&totalSetCount != null&&packages.length>0;

    const handlePrint = () => {
  if (!PDFREADY || downloadingRef.current) return;

  downloadingRef.current = true;

  setPdfProps({
totalSetCount:totalSetCount,
packages:packages ,
headers:headerDetailsP, 
items: eligibleforrelease =="yes"?dataRelease:itemDetailsP, 
computations:computationDetailsP, 
payment:paymentP, 
otherInfo:memberpaymentsDetailsOthers ,
release:eligibleforrelease
  });
};
    //OnLoad Event/Data Fetching SOFgetitrdetails

    //Api Functions SOF
        // Code blocks here
	//Api Request Functions EOF

	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	// const nextpage =  {
	// 	// pathname: "/package-sales-payment",
	// 	pathname: nextPagePath,
	// 	transactionInfo: TransactionInformation, // your data array of objects
	// 	selectedpackagesInfo:TABLE_DATA,
	// 	pageInfo: {
	// 		navid: navid,
	// 		navname: CurrentPage
	// 	}
	// }
	const confirmrelease = () => {
            if(get_cookies('is_operational') == 0 && get_cookies('hqlink') !== null && computationDetails.shipping_fee_display != ""){
	      handleOpenModal();
	    }else{
		handleOpen();
	    }
    }
	const viewITR = () => {
        handleOpen2();
    }
	return (
		!idnoselected ? <Redirect to={"/wholesale-transaction-history/"} /> :
		<div className="page">
			<LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/Wholesale">
						<h2 className="header-title">Wholesale</h2>
					</NavLink>
					<NavLink to={"/wholesale-transaction-history/"}>
						<h2 className="header-title">Wholesale Transaction History</h2>
					</NavLink>
					<Typography color="textPrimary">Wholesale Transaction Details</Typography>
				</Breadcrumbs>

{/* <Box style={{alignItems:'flex-end'}}>
<Button onClick={() => history.goBack()}>Go Back</Button>
</Box> */}
				
			</div>
			<div className="page-container"> 
						    <div>
		<Modal
		  aria-labelledby="transition-modal-title"
		  aria-describedby="transition-modal-description"
		  className={classes.modal}
		  open={openModal}
		  onClose={handleCloseModal}
		  closeAfterTransition
		  BackdropComponent={Backdrop}
		  BackdropProps={{
		    timeout: 500,
		  }}
		>
	  <Fade in={openModal}>
	  <div className={classes.paper}>
	    <h2 id="transition-modal-title">System Message</h2>
	    <form action="" className={classes.root}>
	      <Grid container spacing={3}>
		<Grid item xs={12}>
		  <p>Where do you want to purchase?</p>
		  <FormControl variant="outlined" fullWidth>
		    
	  
		    <InputLabel id="select-place-label">Select Location</InputLabel>
		    <Select
		      labelId="select-place-label"
		      id="select-place"
		      value={selectedPlace}
		 onChange={(e) => {
	    const value = e.target.value;
		const selected = places.find((p) => p.idno === value);
	    setSelectedPlace(value);
	  setSupplerId(selected ? selected.supplier_id : 0);
	  }}
		      label="Select Place"
		    >
		    {places.map((place) => (
			<MenuItem key={place.id} value={place.idno}>
			  {place.branchname}
			</MenuItem>
		      ))}
	
		    </Select>
		  </FormControl>
	
		  {/* <TextField
	      id="outlined-basic"
	      label="Shipping Fee"
	      variant="outlined"
	      required
	      fullWidth
		onChange={(e) => setShippingFee(e.target.value)}
	     style={{ marginTop: '16px', marginBottom: '16px' }}
	      type="number"
	      inputProps={{ min: 0 }}
	      onKeyDown={(e) => {
		if (e.key === '-' || e.key === 'e') {
		  e.preventDefault(); // prevent negative or exponent
		}
	      }}
	    /> */}
		</Grid>
	      </Grid>
	      <div className={classes.button}>
		<Grid container spacing={1}>
		  <Grid item xs={12} sm={2}>
		    <Button
		      variant="contained"
		      onClick={handleCloseModal}
		      className={classes.buttonMarginRight}
		    >
		      No
		    </Button>
		  </Grid>
		  <Grid item xs={12} sm={2}>
		    <Button
		      variant="contained"
		      color="primary"
		      onClick={(e) => {
			console.log("Selected place:", selectedPlace); // debug
			handleCloseModal();
			releasepackage(idnoselected);
		      }}
		    >
		      Yes
		    </Button>
		  </Grid>
		</Grid>
	      </div>
	    </form>
	  </div>
	</Fade>
	
		</Modal>
	      </div>
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				    <Grid container spacing={2} alignItems="stretch" justify="center" className={classes.root}>
					{fs == "no" ? 
						<Grid item xs={6}>
                            <Card>
                                <CardContent>
									<div className={classes.cardStyleHeight}>
										<Grid container spacing={1}>
											<Grid xs={12} sm={6}>
												<h3 className={classes.title}>Transaction Information</h3>
											</Grid>
										</Grid>
										<Grid container>
											<Grid item xs={12}>
												<Grid container>
													<Grid xs={12} sm={12}>
														<h2 className={classes.paddingmarginzero}>{memberpaymentsDetails.soldto}</h2>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Date:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.date}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Reference No.:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.refno}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>ID No.:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.idno}</FormLabel>
													</Grid>
												</Grid>
												{/* <Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>Account Type:</FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.accounttype}</FormLabel>
													</Grid>
												</Grid> */}

												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Account Type:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetailsOthers.packagetype}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Account Type Name:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetailsOthers.packagetypename}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Location:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.location}</FormLabel>
													</Grid>
												</Grid>
												<Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Wholesale Set Amount:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={9}>
														<FormLabel>{memberpaymentsDetails.amount}</FormLabel>
													</Grid>
												</Grid>
												{/* <Grid container>
													<Grid xs={12} sm={3}>
														<FormLabel>  <span style={{ fontWeight: 500 }}>Set:</span></FormLabel>
													</Grid>
													<Grid xs={12} sm={12}>
														<FormLabel>{memberpaymentsDetails.package}</FormLabel>
													</Grid>
												</Grid> */}
											</Grid>
										</Grid>								
									</div>
                                </CardContent>
                            </Card>
                        </Grid>
						: null}
						{!fs == "no" ? 
							<Grid item xs={12}>
							      <Card>
									<CardContent>
										<div className={classes.cardStyleHeight}>
											<Grid container spacing={1}>
												<Grid xs={12} sm={6}>
													<h4 className={classes.title}>Transaction Information</h4>
												</Grid>
												<Grid xs={12} sm={6} >
													<div className={[classes.floatright]}>
														<Grid xs={12} className={classes.paddingmarginzerostyle}>
															<FormLabel className={classes.paddingmarginzerostyle}>{transactionDetails.refno}</FormLabel>
														</Grid>
														<Grid xs={12} className={classes.paddingmarginzerostyle}>
															<FormLabel className={classes.paddingmarginzerostyle}>{transactionDetails.date}</FormLabel>
														</Grid>
													</div>
												</Grid>
											</Grid>
											<Grid container spacing={1}>
												<Grid item xs={12}>
													<Grid container>
														<Grid xs={12} sm={3}>
															<h2 className={classes.title}>{transactionDetails.soldto}</h2>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>ID No.: {transactionDetails.idno}</FormLabel>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>Pin No: {transactionDetails.pinno}</FormLabel>
														</Grid>
													</Grid>
													<Grid container>
														<Grid xs={12} sm={3}>
															<FormLabel>Activation No. {transactionDetails.actno}</FormLabel>
														</Grid>
													</Grid>
												</Grid>
											</Grid>								
										</div>
									</CardContent>
								</Card>
							</Grid>						
						: null}
						{fs == "no" ? 
						<Grid item xs={6}>
							<Grid container>
								<Grid item xs={12}>
									<MUIDataTable
										title={
											<div>
												<div className="table-title">
													Payment Details
												</div>
											</div>
										}
										id="table-grid-payment"
										data={TABLE_DATA_PAYMENT}
										columns={TABLE_COLUMNS_PAYMENT}
										options={TABLE_OPTION_PAYMENT}
									/>
								</Grid>
							</Grid>
                        </Grid>
						: null}
						
						<Grid item xs={12} className="noprint">
							<Grid container spacing={2}>
								{packages != ""? 								<Grid item xs={12}>
												<MUIDataTable
												title={
													<div>
														<div className="table-title">
															Set
														</div>
													</div>
												}
												id="table-grid"
												data={packages}
												columns={TABLE_COLUMNS_SET}
												options={TABLE_OPTION_SET}
												/>
								</Grid>:null}

								<Grid item xs={12}>
									{eligibleforrelease =="yes" ?
																				<MUIDataTable
																				title={
																					<div>
																						<div className="table-title">
																							Item Details
																						</div>
																					</div>
																				}
																				id="table-grid"
																				data={TABLE_DATA_ITR}
												columns={TABLE_COLUMNS_ITR}
												options={TABLE_OPTION_ITR}
																				/>
									: 
										<MUIDataTable
										title={
											<div>
												<div className="table-title">
													Item Details
												</div>
											</div>
										}
										id="table-grid"
										data={TABLE_DATA_ITEMS}
										columns={TABLE_COLUMNS_ITEMS}
										options={{...TABLE_OPTION_ITEMS,
											customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => (
												computationDetails.total_amount_display? 												<div style={{ display: "flex", justifyContent: "flex-end", padding: "20px" }}>
												<span style={{ fontWeight: "bold" }}>Total Amount: {computationDetails.total_amount_display}</span>
											      </div>:null

											      ),
										      }}
										/>
									}									
								</Grid>
							</Grid>
                        </Grid>
						{!fs == "no" ?
							<Grid item xs={12} className="yesprint"> 
								<Card>
									<CardContent>
									{eligibleforrelease =="yes" ? 
										<img src={notreleaseimg} />
									: 
										<Grid container spacing={2}>
										<Grid item xs={2}>No.</Grid>
										<Grid item xs={2}>Item Name</Grid>
										<Grid item xs={2}>Qty</Grid>
										<Grid item xs={2}>Unit</Grid>
										<Grid item xs={2}>Price</Grid>
										<Grid item xs={2}>Total</Grid>
										</Grid>
									}
									</CardContent>
								</Card>
							</Grid>
						: null}
						{fs == "no" ? 
						<Grid container justifyContent={"space-between"}>
						<Grid item xs={6}>
						<Grid container className={[classes.margintop,"noprint"]}>
						{eligibleforrelease =="yes" ? <div>
							{/* <Button 
								variant="contained" 
								color="primary"
								onClick={(e) => {viewITR()}}
							>
								View Items
							</Button> */}
																	{get_cookies('can_process') == 1 ?
											<Button 
												variant="contained" 
												color="primary"
												onClick={(e) => {confirmrelease();handleClose2();}}
											>
												Release
											</Button> :null}
							</div> : null}
						
						<Grid item xs={12} sm={8}>
							{fs == "no" ? 
							<div className={classes.printButton}>
								{/* {pdfProps&&(<PDFDownloadLink  
									document={eligibleforrelease == "yes"?(<PdfDocumentRelease className="MuiButton-root" {...pdfProps}/>):(<PdfDocument className="MuiButton-root" {...pdfProps}/>)}
									fileName={"WHOLESALE_"+idnoselected+".pdf"}
								>
										
									{({ blob, url, loading, error }) =>
							      <Button disabled={loading} style={{ marginLeft: 10 }}>
										{loading ? 'Preparing…' : 'Download PDF'}
									</Button>
									//               <Button
									// 	variant="contained"
									// 	color="success"
									// 	disabled={loading}
									// 	style={{ backgroundColor: "green", width: "250px", marginLeft: "10px" ,color:"#fff" }}
									// >
									// 	{loading ? "Preparing PDF..." : "Print Wholesale Set"}
									// </Button>
									}
								</PDFDownloadLink>)} */}
								{pdfProps && (<BlobProvider document={eligibleforrelease == "yes"?(<PdfDocumentRelease className="MuiButton-root" {...pdfProps}/>):(<PdfDocument className="MuiButton-root" {...pdfProps}/>)}>
											{({ blob, loading }) => {
								if (loading || !blob) return null;

								const url = URL.createObjectURL(blob);

								const a = document.createElement('a');
								a.href = url;
								a.download = "WHOLESALE_"+idnoselected+".pdf";
								a.click();

								URL.revokeObjectURL(url);

	
								downloadingRef.current = false;
								setPdfProps(null);

								return null;
								}}
								</BlobProvider>)}
							<Button
							variant="contained"
							color="success"
							disabled={!PDFREADY}
							onClick={handlePrint}
							style={{ backgroundColor: "#339933", width: "250px", marginLeft: "10px" ,color:"#fff" }}
							>
							Print Wholesale Set
							</Button>
							</div>
							: 
							<Button onClick={(e) => {window.print();}} variant="contained" 
						 style={{
								color: "#FFF",
								backgroundColor: "green"}}>WHOLESALE_"+idnoselected+".pdf</Button>
							}
						</Grid>
	
							</Grid>
						</Grid>
						<Grid item xs={6}>

						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
							{!computationDetails.shipping_fee_display == ""  &&  !computationDetails.grandtotal == "" ?
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Shipping: "+ computationDetails.shipping_fee_display}							
								</div>
							: null}
							{!computationDetails.discount == "" ?
								<div className={classes.infoTotalItem}>
									<LoyaltyTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Discount: "+ computationDetails.discount}							
								</div>
							: null}
							{!computationDetails.netamountnovat == "" ?
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Net Amount: "+ computationDetails.netamountnovat}							
								</div>
							: null}
							{!computationDetails.vatamount == "" ?
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{/* Shipping: 0.00	shipTotal	 */}
									{"Vat Amount: "+ computationDetails.vatamount}							
								</div>
							: null}

								{/* <div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total Amount: "+computationDetails.total_amount_display}
								</div> */}
									{!computationDetails.grandtotal == "" ?
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Grand Total: "+ computationDetails.grandtotal}
								</div>	:null}
							</div>
						</div>
{/* 
						<Grid container>
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Total Amount: {computationDetails.total_amount_display}</h4>
								</Grid>
								{!computationDetails.shipping_fee_display == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Shipping/Freight: {computationDetails.shipping_fee_display}</h4>
								</Grid>
								: null}
								{!computationDetails.discount == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Discount: {computationDetails.discount}</h4>
								</Grid>
								: null}
								{!computationDetails.netamountnovat == "" ?
								<Grid  item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Net Amount: {computationDetails.netamountnovat}</h4>
								</Grid>
								: null}
								{!computationDetails.vatamount == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>VAT Amount: {computationDetails.vatamount}</h4>
								</Grid>
								: null}
								{!computationDetails.grand_total_amount_display == "" ?
								<Grid item xs={12}>
									<h4 style={{marginTop:2,marginBottom:10}} className={classes.floatright}>Grand Total: {computationDetails.grand_total_amount_display}</h4>
								</Grid>
								: null}
						</Grid> */}
						</Grid>
						</Grid>

						: null}
                    </Grid>

					<div>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal}
						open={open}
						onClose={handleClose}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500,
						}}
					>
						<Fade in={open}>
							<div className={classes.paper}>
								<h2 id="transition-modal-title">System Message</h2>
								<form action="" className={classes.root}>
									<Grid container spacing={3}>
										<Grid item xs={12}>
											Are you sure you want to release this package?
										</Grid>
									</Grid>
									<div className={classes.button}>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={5}>
											<Button
												variant="contained"
												onClick={handleClose}
												className={classes.buttonMarginRight}
											>
												No
											</Button>
										</Grid>
										<Grid item xs={12} sm={5}>
											<Button 
											disabled={disabledBtnYes}
												variant="contained" 
												color="primary"
												onClick={(e) => {releasepackage(idnoselected);handleClose();}}
											>
												Yes
											</Button>
										</Grid>

										</Grid>
									</div>
								</form>
							</div>
						</Fade>
					</Modal>
					</div>
					{/* Item Details TABLE Modal */}
					<div>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal_itr}
						open={open2}
						onClose={handleClose2}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500,
						}}
					>
						<Fade in={open2}>
							<div className={classes.paper}>
								<h2 id="transition-modal-title">Items to Release</h2>
								<form action="" className={classes.root}>
									<Grid container spacing={2}>
										<Grid item xs={12}>
											<MUIDataTable
												title={
													<div>
														<div className="table-title">
															Item Details
														</div>
													</div>
												}
												id="table-grid-itr"
												data={TABLE_DATA_ITR}
												columns={TABLE_COLUMNS_ITR}
												options={TABLE_OPTION_ITR}
											/>
										</Grid>
									</Grid>
									<div className={[classes.button, classes.margintop]}>
									<Grid container spacing={2}>
										<Grid item xs={12} sm={2}>
											<Button
												variant="contained"
												onClick={handleClose2}
												className={classes.buttonMarginRight}
											>
												Close
											</Button>
										</Grid>
										<Grid item xs={12} sm={2}>
										{get_cookies('can_process') == 1 ?
											<Button 
												disabled={disabledBtnYes}
												variant="contained" 
												color="primary"
												onClick={(e) => {confirmrelease();handleClose2();}}
											>
												Release
											</Button> :null}

										</Grid>

										</Grid>
									</div>
								</form>
							</div>
						</Fade>
					</Modal>
					</div>
                </form>
			</div>
			</LoadingOverlay>
		</div>
	);
};

export default WholesaleTransactionDetails;
